const originalFetch = window.fetch;

const fetchOverwrite = (getAccessTokenSilently) => {
    // Overwrite window.fetch
    // to include the auth0 jwt
    // in each request made to funnel backend and any where else that needs a quility auth0 bearer token
    window.fetch = async (...args) => {
        let [resource, config] = args;
        let ignore = true
        let reqURL = null

        const validOrgins = process.env.REACT_APP_VALID_REQUEST_ORIGINS ? process.env.REACT_APP_VALID_REQUEST_ORIGINS.split(',').map(o => o.trim()) : []

        // check if request is being made to funnel api
        if (typeof resource === 'object' && resource !== null && typeof resource.url === 'string' && typeof resource.method === 'string') {
            reqURL = new URL(resource.url)
        } else if (typeof resource === 'string') {
            try {
                reqURL = new URL(resource)
            } catch (error) {
                throw new Error(error)
            }
        }

        if (reqURL) {
            ignore = !validOrgins.includes(reqURL.origin)
        }

        // attach auth jwt as the bearer token here
        if (!ignore) {
            try {
                // call getTokenSilently
                const token = await getAccessTokenSilently({
                    detailedResponse: true,
                    authorizationParams: {
                        audience: process.env.REACT_APP_HQ_AUTH0_AUDIENCE
                    }
                });

                // modify config and add appropriate header
                config.headers = {
                    ...config.headers,
                    'Authorization': `Bearer ${token?.access_token ?? ''}`
                }
            } catch (error) {
                console.error('getAccessTokenSilently failed:', error);
                // Optionally trigger login or handle gracefully
            }
        }

        const response = originalFetch(resource, config)
        return response
    }
}

const restoreFetch = () => {
    window.fetch = originalFetch
}

export { fetchOverwrite, restoreFetch }